(function () {
  // ==== CONFIG ====
  const THRESHOLD = 0.25; // Baja el umbral (25% visible) para asegurar play
  const SCOPE_SELECTORS = [
    '.product-slideshow__slider',
    '.product__media-wrapper',
    '.product-slideshow'
  ].join(',');

  // Respeta accesibilidad
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // ==== HELPERS GENERALES ====
  const isEl = (n) => n instanceof HTMLElement;
  const isVideo = (n) => isEl(n) && n.tagName === 'VIDEO';
  const isIframe = (n) => isEl(n) && n.tagName === 'IFRAME';
  const isYT = (f) => isIframe(f) && /\b(youtube\.com|youtu\.be)\b/i.test(f.src || f.dataset.src || '');
  const isVM = (f) => isIframe(f) && /\bvimeo\.com\b/i.test(f.src || f.dataset.src || '');

  function setIfMissing(el, attr, val) {
    if (!el.getAttribute(attr)) el.setAttribute(attr, val);
  }

  // Forzar autoplay-friendly en HTML5
  function prepHTML5(v) {
    v.muted = true;
    v.playsInline = true;
    v.setAttribute('playsinline', '');
    setIfMissing(v, 'preload', 'metadata');
    // Truco para temas que requieren gesto: marcamos autoplay y luego play()
    setIfMissing(v, 'autoplay', '');
    // Algunos temas ponen controls=true; no afecta el autoplay pero puede confundir
  }

  // Normalizar iframes (allow + params + origin + playsinline)
  function prepYouTube(iframe) {
    // allow autoplay
    setIfMissing(iframe, 'allow', 'autoplay; encrypted-media; fullscreen; picture-in-picture');
    // mover data-src -> src si está lazy
    ensureSrcFromData(iframe);

    try {
      const u = new URL(iframe.src, window.location.origin);
      if (!u.searchParams.has('enablejsapi')) u.searchParams.set('enablejsapi', '1');
      if (!u.searchParams.has('playsinline')) u.searchParams.set('playsinline', '1');
      if (!u.searchParams.has('origin')) u.searchParams.set('origin', location.origin);
      iframe.src = u.toString();
    } catch (e) {}
  }

  function prepVimeo(iframe) {
    setIfMissing(iframe, 'allow', 'autoplay; encrypted-media; fullscreen; picture-in-picture');
    ensureSrcFromData(iframe);

    try {
      const u = new URL(iframe.src, window.location.origin);
      if (!u.searchParams.has('autopause')) u.searchParams.set('autopause', '0');
      if (!u.searchParams.has('muted')) u.searchParams.set('muted', '1');
      if (!u.searchParams.has('playsinline')) u.searchParams.set('playsinline', '1');
      iframe.src = u.toString();
    } catch (e) {}
  }

  function ensureSrcFromData(el) {
    // Maneja lazyload común: data-src, data-video, data-url
    const candidates = ['data-src', 'data-video', 'data-url'];
    for (const a of candidates) {
      const v = el.getAttribute(a);
      if (v && !el.getAttribute('src')) {
        el.setAttribute('src', v);
        break;
      }
    }
  }

  // ==== PLAY / PAUSE ====
  function playHTML5(v) {
    prepHTML5(v);
    try { v.play().catch(() => {}); } catch (e) {}
  }
  function pauseHTML5(v) { try { v.pause(); } catch (e) {} }

  function playYT(iframe) {
    prepYouTube(iframe);
    try {
      iframe.contentWindow?.postMessage(JSON.stringify({event:'command',func:'mute',args:[]}), '*');
      iframe.contentWindow?.postMessage(JSON.stringify({event:'command',func:'playVideo',args:[]}), '*');
    } catch (e) {}
  }
  function pauseYT(iframe) {
    try { iframe.contentWindow?.postMessage(JSON.stringify({event:'command',func:'pauseVideo',args:[]}), '*'); } catch (e) {}
  }

  function playVM(iframe) {
    prepVimeo(iframe);
    try {
      iframe.contentWindow?.postMessage({ method:'setMuted', value:true }, '*');
      iframe.contentWindow?.postMessage({ method:'play' }, '*');
    } catch (e) {}
  }
  function pauseVM(iframe) {
    try { iframe.contentWindow?.postMessage({ method:'pause' }, '*'); } catch (e) {}
  }

  // ==== DETECCIÓN DE SLIDE ACTIVO ====
  function isSlideActive(el) {
    // Muchos temas marcan el slide activo con alguna de estas clases/atributos
    return el.closest('.is-active, .is-selected, [aria-current="true"], .slick-current, .swiper-slide-active') != null;
  }

  // Pausa todo salvo el nodo visible/activo
  function pauseOthers(current) {
    const scope = current.closest(SCOPE_SELECTORS) || document;
    scope.querySelectorAll('video,iframe').forEach(node => {
      if (node === current) return;
      if (isVideo(node)) pauseHTML5(node);
      else if (isYT(node)) pauseYT(node);
      else if (isVM(node)) pauseVM(node);
    });
  }

  // ==== OBSERVERS ====
  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const el = entry.target;
      const visible = entry.intersectionRatio >= THRESHOLD;

      // Extra: algunos carruseles exigen que el slide esté marcado como activo
      const activeOK = visible || isSlideActive(el);

      if (isVideo(el)) {
        if (activeOK) { playHTML5(el); pauseOthers(el); }
        else { pauseHTML5(el); }
      } else if (isIframe(el)) {
        if (isYT(el)) {
          if (activeOK) { playYT(el); pauseOthers(el); }
          else { pauseYT(el); }
        } else if (isVM(el)) {
          if (activeOK) { playVM(el); pauseOthers(el); }
          else { pauseVM(el); }
        }
      }
    });
  }, { threshold: [0, THRESHOLD, 0.75, 1] });

  function observeNode(el) {
    if (!isEl(el)) return;
    if (isVideo(el)) {
      prepHTML5(el);
      io.observe(el);
    } else if (isIframe(el)) {
      if (isYT(el)) prepYouTube(el);
      if (isVM(el)) prepVimeo(el);
      io.observe(el);
    }
    // Si el nodo contiene medios dentro
    el.querySelectorAll?.('video,iframe').forEach(child => observeNode(child));
  }

  // Re-sincronizar al cambiar de slide/clase/estilo
  function forceRecalc() { window.requestAnimationFrame(() => window.scrollBy(0, 0)); }

  // Mutations (nuevos slides + cambios de clases del carrusel)
  const mo = new MutationObserver(muts => {
    muts.forEach(m => {
      m.addedNodes.forEach(n => { if (isEl(n)) observeNode(n); });
      if (m.type === 'attributes' && (m.attributeName === 'class' || m.attributeName === 'style')) {
        forceRecalc();
      }
    });
  });

  function attach() {
    document.querySelectorAll(SCOPE_SELECTORS).forEach(scope => {
      scope.querySelectorAll('video,iframe').forEach(el => observeNode(el));
      mo.observe(scope, { childList:true, subtree:true, attributes:true, attributeFilter:['class','style'] });
    });
    // Por si el scope aparece tarde
    mo.observe(document.body, { childList:true, subtree:true });
  }

  function init() { attach(); }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();